import { ReactNode } from 'react';

import { CoveoAnalyticsContext } from './coveoAnalytics.context';

interface CoveoAnalyticsProps {
  children: ReactNode;
  apiKey?: string;
  endpoint?: string;
}

export const CoveoAnalyticsProvider = ({
  children,
  apiKey,
  endpoint,
}: CoveoAnalyticsProps): React.JSX.Element => {
  const coveoAnalyticsContext = {
    apiKey: apiKey,
    endpoint: endpoint,
  };

  return (
    <CoveoAnalyticsContext.Provider value={coveoAnalyticsContext}>
      {children}
    </CoveoAnalyticsContext.Provider>
  );
};
